import { ACCESS_CLEARED } from "../../../redux/reducers/accessReducer";
import {
  collectionReducer,
  initialCollectionState,
  initialResourceState,
  resourceReducer,
} from "./facilitatorDashboardState";

export const FACILITATOR_WORKSPACE_OPENED = "unityFacilitator/workspaceOpened";
export const FACILITATOR_WORKSPACE_CLOSED = "unityFacilitator/workspaceClosed";
export const FACILITATOR_RESOURCE_CHANGED = "unityFacilitator/resourceChanged";

export const createFacilitatorWorkspaceState = () => ({
  sessionId: null,
  scopeKey: null,
  portfolio: { ...initialCollectionState, items: [] },
  intakeOptions: { ...initialCollectionState, items: [] },
  intake: initialResourceState(),
});

const initialState = createFacilitatorWorkspaceState();

export default function facilitatorWorkspaceReducer(state = initialState, { type, payload } = {}) {
  if (type === ACCESS_CLEARED) return createFacilitatorWorkspaceState();
  if (type === FACILITATOR_WORKSPACE_OPENED && payload?.sessionId) {
    return { ...createFacilitatorWorkspaceState(), sessionId: payload.sessionId, scopeKey: payload.scopeKey };
  }
  if (!state.sessionId || state.sessionId !== payload?.sessionId) return state;
  if (type === FACILITATOR_WORKSPACE_CLOSED) return createFacilitatorWorkspaceState();
  if (type !== FACILITATOR_RESOURCE_CHANGED || !payload.action) return state;
  const { resource, action } = payload;
  if (resource !== "portfolio" && resource !== "intakeOptions" && resource !== "intake") return state;
  let next;
  if (resource === "intake") {
    // A departing page may clear only the request it owned, never its successor.
    next = action.type === "reset"
      ? (state.intake.requestId === action.requestId ? initialResourceState() : state.intake)
      : resourceReducer(state.intake, action);
  } else {
    next = collectionReducer(state[resource], action);
  }
  return next === state[resource] ? state : { ...state, [resource]: next };
}

export const selectUnityFacilitator = (state) => state.unityFacilitator;
export const selectFacilitatorPortfolio = (state) => selectUnityFacilitator(state).portfolio;
export const selectFacilitatorIntakeOptions = (state) => selectUnityFacilitator(state).intakeOptions;
export const selectFacilitatorIntake = (state) => selectUnityFacilitator(state).intake;

export function facilitatorWorkspaceScope(access, legacyMigrationOnly = false) {
  return JSON.stringify([
    access?.user?.uid,
    access?.tenant?.tenantId,
    access?.tenant?.company,
    access?.tenant?.collectionBrand,
    access?.tenant?.tenantRole,
    access?.productAccess?.tenant?.accessVersion,
    access?.roles,
    access?.permissions,
    access?.modules,
    legacyMigrationOnly,
  ]);
}
